(() => {
  const configElement = document.getElementById('hp-personaclick-config');
  if (!configElement || window.HpPersonaClick) return;
  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch {
    return;
  }
  const nativeFetch = window.fetch.bind(window);
  const sourceKey = 'hp-personaclick-source';
  let initialized = false;
  let trackingStarted = false;
  let fullSearchProductView = false;
  let profileStarted = false;
  let cartTimer = 0;
  let cartRevision = 0;
  let lastCart = null;
  let forceCart = false;
  const newsletterKey = 'hp-personaclick-newsletter';
  const confirmedActions = new Set();
  let privacyRevision = 0;
  let customerRefreshRevision = 0;
  let customerRefreshTimer = 0;
  let newsletterInFlight = null;
  let queueFunction = null;
  let serverTimeReceived = performance.now();
  const registrationSent = new Set();
  const wishlistIntents = new Set();
  let wishlistSequence = 0;
  let cartFavoriteTrigger = null;
  let lastCartFavoriteAction = -Infinity;
  let alertSequence = 0;
  let privacyTimer = 0;
  let privacyLoading = false;
  let privacyAttempts = 0;
  const trackingConsent = createTrackingConsentBridge();

  function createTrackingConsentBridge() {
    if (!document.getElementById('ucookie')) return null;
    const storageKey = 'hp-kip-ucookie-confirmed-v1';
    const widgetId = '678163d6-4da6-4494-a127-142381c22200';
    const denied = () => ({ analytics: false, marketing: false, preferences: false });
    let choice = denied();
    let revision = 0;
    let pending = false;
    let saving = false;
    let synchronized = false;
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
      if (saved?.widgetId === widgetId && ['analytics', 'marketing', 'preferences'].every(key => typeof saved.choice?.[key] === 'boolean')) choice = saved.choice;
    } catch {}
    const notify = () => document.dispatchEvent(new Event('hp:tracking-consent-changed'));
    function sync() {
      const privacy = window.Shopify?.customerPrivacy;
      if (saving || synchronized || typeof privacy?.setTrackingConsent !== 'function') return;
      saving = true;
      const version = revision;
      try {
        privacy.setTrackingConsent({ ...choice }, error => {
          saving = false;
          if (version !== revision) { sync(); return; }
          synchronized = !error;
          notify();
        });
      } catch { saving = false; }
    }
    function request(input, options) {
      try {
        const url = new URL(typeof input === 'string' ? input : input.url, window.location.href);
        if (url.origin !== 'https://panel.ucookie.com.tr' || url.pathname !== '/visitor/set-consents' || String(options?.method || input.method || 'GET').toUpperCase() !== 'POST') return null;
        const body = JSON.parse(options.body);
        if (!body.visitor_id) return null;
        const selected = {
          analytics: body['2d39c076-3683-4430-99c3-6e70369f248c'] === true,
          marketing: body['86f60cdb-6261-4a86-8a63-a3f08fa478ff'] === true,
          preferences: body['95cc2f19-1159-45bf-a295-4f9b806c7ee2'] === true,
        };
        const version = ++revision;
        pending = true;
        choice = denied();
        synchronized = false;
        try { localStorage.removeItem(storageKey); } catch {}
        notify();
        sync();
        return async response => {
          try {
            if (!response.ok || (await response.clone().json()).message !== 'success' || revision !== version) return;
            choice = selected;
            pending = false;
            revision += 1;
            synchronized = false;
            try { localStorage.setItem(storageKey, JSON.stringify({ widgetId, choice })); } catch {}
            sync();
          } catch {}
        };
      } catch { return null; }
    }
    document.addEventListener('click', event => {
      const link = event.target.closest?.('a[href="#"]');
      const linkText = link?.textContent.trim().toLocaleLowerCase('tr-TR');
      if (!['çerez tercihleri', 'cookie preferences', 'cookie settings'].includes(linkText) || typeof window.generate_modal !== 'function') return;
      event.preventDefault();
      if (!document.getElementById('ucookie-modal-container')) window.generate_modal();
    });
    const bridge = { allows: () => !pending && synchronized && choice.analytics && choice.marketing, resolved: () => !pending && !saving && synchronized, sync, request };
    window.HpTrackingConsent = bridge;
    return bridge;
  }

  function timestamp(value) {
    const text = String(value ?? '').trim();
    if (/^\d{10}$/.test(text)) return Number(text) * 1000;
    if (/^\d{13}$/.test(text)) return Number(text);
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})$/.test(text)) return NaN;
    if (!birthdayValue(text.slice(0, 10)) || Number(text.slice(11, 13)) > 23 || Number(text.slice(14, 16)) > 59 || Number(text.slice(17, 19)) > 59) return NaN;
    return Date.parse(text);
  }

  function birthdayValue(value) {
    const text = String(value || '').trim();
    const turkish = text.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    const date = turkish ? `${turkish[3]}-${turkish[2]}-${turkish[1]}` : text;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || Number.isNaN(Date.parse(date))) return '';
    return new Date(date).toISOString().slice(0, 10) === date ? date : '';
  }

  function newCustomerEligible(customerId, createdDate) {
    if (String(config.customer?.id) !== String(customerId) || config.customerCreatedDate !== createdDate) return false;
    const now = timestamp(config.serverTime) + performance.now() - serverTimeReceived;
    const age = now - registrationStartedAt(customerId, createdDate, now);
    return Number.isFinite(age) && age >= 0 && age < 7200000;
  }

  function registrationKey(customerId) {
    return `hp-personaclick-registration:${config.shopId}:${customerId}`;
  }

  function registrationStartedAt(customerId, createdDate, now) {
    const exact = timestamp(createdDate);
    if (Number.isFinite(exact)) return exact;
    const date = String(createdDate ?? '').trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || birthdayValue(date) !== date || !Number.isFinite(now)) return NaN;
    const zone = String(config.serverTime).match(/(?:Z|[+-]\d{2}:?\d{2})$/)?.[0];
    if (!zone) return NaN;
    const dayStart = timestamp(`${date}T00:00:00${zone}`);
    if (!Number.isFinite(dayStart) || now < dayStart || now >= dayStart + 86400000) return NaN;
    try {
      const key = `${registrationKey(customerId)}:first-seen`;
      const saved = sessionStorage.getItem(key);
      if (saved !== null) {
        const observed = JSON.parse(saved);
        if (observed?.date !== date || !Number.isFinite(observed.time) || observed.time < dayStart || observed.time > now) return NaN;
        return observed.time;
      }
      sessionStorage.setItem(key, JSON.stringify({ date, time: now }));
      return now;
    } catch { return NaN; }
  }

  function registrationRecorded(key) {
    if (registrationSent.has(key)) return true;
    try { return sessionStorage.getItem(key) === '1'; } catch { return false; }
  }

  function consentAllowed() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return (!trackingConsent || trackingConsent.allows()) && privacy?.analyticsProcessingAllowed?.() === true && privacy?.marketingAllowed?.() === true;
    } catch {
      return false;
    }
  }

  function send(...args) {
    const behavioralEvent = args[0] === 'track' && ['view', 'category', 'search', 'cart', 'wish', 'remove_wish'].includes(args[1]);
    if (!initialized || (!behavioralEvent && !consentAllowed())) return false;
    try {
      window.personaclick(...args);
      return true;
    } catch {
      return false;
    }
  }

  function aggregateCart(items) {
    const products = new Map();
    for (const item of items) {
      const id = String(item.product_id || '');
      const quantity = Number(item.quantity);
      if (!id || !Number.isInteger(quantity) || quantity <= 0) continue;
      products.set(id, (products.get(id) || 0) + quantity);
    }
    return Array.from(products, ([id, amount]) => ({ id, amount })).sort((first, second) => first.id.localeCompare(second.id));
  }

  async function syncCart() {
    if (!initialized) return;
    const revision = cartRevision;
    try {
      const response = await nativeFetch(config.cartUrl, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (revision !== cartRevision || !Array.isArray(cart.items)) return;
      const products = aggregateCart(cart.items);
      const signature = JSON.stringify(products);
      if (forceCart || signature !== lastCart) {
        if (send('track', 'cart', products)) {
          lastCart = signature;
          forceCart = false;
        }
      }
    } catch {
      return;
    }
  }

  function scheduleCartSync(force = false) {
    if (!initialized) return;
    cartRevision += 1;
    forceCart = forceCart || force;
    window.clearTimeout(cartTimer);
    cartTimer = window.setTimeout(syncCart, 80);
  }

  function profileUpdated(customer, options = {}) {
    if (!customer || !initialized || !consentAllowed()) return false;
    const profile = {};
    for (const key of ['id', 'email', 'first_name', 'last_name']) {
      if (typeof customer[key] === 'string' && customer[key].trim()) profile[key] = customer[key].trim();
    }
    if (typeof customer.id === 'number' && Number.isSafeInteger(customer.id) && customer.id > 0) profile.id = String(customer.id);
    if (profile.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(profile.email)) delete profile.email;
    const phone = String(customer.phone || '').replace(/\D/g, '').replace(/^0(?=5\d{9}$)/, '90').replace(/^(?=5\d{9}$)/, '90');
    if (/^905\d{9}$/.test(phone)) profile.phone = phone;
    const gender = String(customer.gender || '').trim().toLocaleLowerCase('tr-TR');
    if (['m', 'male', 'erkek'].includes(gender)) profile.gender = 'm';
    if (['f', 'female', 'kadın', 'kadin'].includes(gender)) profile.gender = 'f';
    const birthday = birthdayValue(customer.birthday);
    if (birthday) profile.birthday = birthday;
    if (!profile.email && !profile.phone) return false;
    if (options.registration && !profile.id) return false;
    let completed = false;
    const revision = privacyRevision;
    return send('profile', 'set', profile, () => {
      if (completed || revision !== privacyRevision || !consentAllowed() || (options.isCurrent && !options.isCurrent())) return;
      completed = true;
      const segmentId = options.registration ? '68123' : options.newsletter ? '68124' : '';
      const key = options.registration ? registrationKey(profile.id) : '';
      if (segmentId && (!options.registrationEligible || options.registrationEligible()) && (!key || !registrationRecorded(key))) {
        if (!send('segment', 'add', { ...(profile.email ? { email: profile.email } : { phone: profile.phone }), segment_id: segmentId })) {
          options.onError?.();
          return;
        }
        if (key) {
          registrationSent.add(key);
          try { sessionStorage.setItem(key, '1'); } catch {}
        }
      }
      options.onSuccess?.();
    }, () => {
      if (completed) return;
      completed = true;
      options.onError?.();
    });
  }

  function wishlistChanged({ productId, added, operationId } = {}) {
    if (!/^[1-9]\d*$/.test(String(productId || '')) || typeof added !== 'boolean' || !operationId) return false;
    if (confirmedActions.has(operationId)) return false;
    if (!send('track', added ? 'wish' : 'remove_wish', String(productId))) return false;
    confirmedActions.add(operationId);
    if (confirmedActions.size > 200) confirmedActions.delete(confirmedActions.values().next().value);
    return true;
  }

  function productId(value) {
    if (typeof value === 'number' && !Number.isSafeInteger(value)) return '';
    return String(value ?? '').match(/^(?:gid:\/\/shopify\/Product\/)?([1-9]\d*)$/)?.[1] || '';
  }

  function storedWishlistContains(id) {
    try {
      const products = JSON.parse(localStorage.getItem('hollyWishListProducts') || '[]');
      return Array.isArray(products) ? products.some(product => productId(product.productId) === id) : null;
    } catch { return null; }
  }

  function confirmWishlist(intent) {
    if (!wishlistIntents.delete(intent)) return;
    wishlistChanged(intent);
  }

  function watchWishlist(id, added) {
    if (!initialized) return;
    if (!id) return;
    const intent = { productId: id, added, operationId: `holly:${++wishlistSequence}`, claimed: false };
    const before = config.customer?.id ? null : storedWishlistContains(id);
    wishlistIntents.add(intent);
    const started = performance.now();
    const check = () => {
      if (!wishlistIntents.has(intent)) return;
      if (performance.now() - started >= 15000) {
        wishlistIntents.delete(intent);
        return;
      }
      if (before !== null && before !== intent.added && storedWishlistContains(id) === intent.added) confirmWishlist(intent);
      else window.setTimeout(check, 250);
    };
    window.setTimeout(check, 0);
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest?.('.js-open-remove-modal[data-product_id]');
    if (trigger) cartFavoriteTrigger = trigger;
    const button = event.target.closest?.('.holly-wishlist[data-product_id], .wishlist_icon[data-holly_product_id]');
    if (!button) return;
    const id = productId(button.dataset.product_id || button.dataset.holly_product_id);
    watchWishlist(id, button.matches('.wishlist_icon') ? false : button.dataset.favorite !== 'true');
  }, true);

  function watchCartFavorite(event) {
    const button = event.target.closest?.('.js-remove-and-favorite');
    if (!button || button.disabled || !cartFavoriteTrigger || (event.type === 'pointerup' && event.button !== 0)) return;
    if (performance.now() - lastCartFavoriteAction < 350) return;
    lastCartFavoriteAction = performance.now();
    watchWishlist(productId(cartFavoriteTrigger.dataset.product_id), true);
  }

  document.addEventListener('pointerup', watchCartFavorite, true);
  document.addEventListener('click', watchCartFavorite, true);

  function wishlistRequest(input, options) {
    try {
      const url = new URL(typeof input === 'string' ? input : input.url, window.location.href);
      const action = url.pathname.match(/^\/apps\/holly-wishlist\/favorite\/(add|remove)$/)?.[1];
      if (url.origin !== window.location.origin || !action) return null;
      const method = String(options?.method || input.method || 'GET').toUpperCase();
      if (method !== (action === 'add' ? 'POST' : 'DELETE') || typeof options?.body !== 'string') return null;
      const id = productId(JSON.parse(options.body).productId);
      if (!id || !initialized) return null;
      const intent = Array.from(wishlistIntents).find(item => !item.claimed && item.productId === id && item.added === (action === 'add'));
      if (intent) {
        intent.claimed = true;
        return intent;
      }
      const request = { productId: id, added: action === 'add', operationId: `holly:${++wishlistSequence}`, claimed: true };
      wishlistIntents.add(request);
      window.setTimeout(() => wishlistIntents.delete(request), 15000);
      return request;
    } catch { return null; }
  }

  function alertChanged({ productId: id, type, subscribed, email, size = '', sizeRequired = false, price, operationId } = {}) {
    id = productId(id);
    if (!id || !['stock', 'price'].includes(type) || typeof subscribed !== 'boolean' || !operationId || confirmedActions.has(operationId)) return false;
    if (typeof email !== 'string' || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) return false;
    const trigger = type === 'stock' ? 'product_available' : 'product_price_decrease';
    let payload = { email: email.trim(), item_ids: [id] };
    if (subscribed) {
      if (type === 'stock' && sizeRequired && !String(size).trim()) return false;
      if (type === 'price' && (typeof price !== 'number' || !Number.isFinite(price) || price < 1)) return false;
      payload = { email: email.trim(), item: id };
      if (type === 'stock' && String(size).trim()) payload.properties = { fashion_size: String(size).trim() };
      if (type === 'price') payload.price = price;
    }
    if (!send(subscribed ? 'subscribe_trigger' : 'unsubscribe_trigger', trigger, payload)) return false;
    confirmedActions.add(operationId);
    if (confirmedActions.size > 200) confirmedActions.delete(confirmedActions.values().next().value);
    return true;
  }

  function alertRequest(input, options) {
    if (!initialized || !consentAllowed()) return null;
    try {
      const url = new URL(typeof input === 'string' ? input : input.url, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== '/apps/holly-notifications/Track/add' || String(options?.method || input.method || 'GET').toUpperCase() !== 'POST') return null;
      const body = JSON.parse(options.body);
      const id = productId(body.productId);
      const variantId = String(body.productVariantId || '').replace(/^gid:\/\/shopify\/ProductVariant\//, '');
      if (!id || !['InStock', 'Discount'].includes(body.trackingType)) return null;
      const variant = config.alertVariants?.find(item => item.id === variantId && item.productId === id);
      const button = Array.from(document.querySelectorAll('[data-hp-pc-price][data-product_id][data-variant_id]')).find(item => productId(item.dataset.product_id) === id && item.dataset.variant_id === variantId);
      if (!variant && !button) return null;
      const price = variant ? variant.price : Number(button.dataset.hpPcPrice);
      return {
        productId: id, type: body.trackingType === 'InStock' ? 'stock' : 'price', subscribed: true,
        email: body.email, size: variant ? variant.size : button.dataset.hpPcSize || '',
        sizeRequired: variant ? variant.sizeRequired : button.hasAttribute('data-hp-pc-size'), price,
        operationId: `holly-alert:${++alertSequence}`, revision: privacyRevision,
      };
    } catch { return null; }
  }

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!consentAllowed() || !form.matches?.('[data-hp-personaclick-newsletter]')) return;
    const email = form.querySelector('[name="contact[email]"]')?.value.trim();
    const accepted = form.querySelector('[data-newsletter-consent]')?.checked === true;
    if (!email || !accepted || !form.checkValidity()) return;
    try {
      sessionStorage.setItem(newsletterKey, JSON.stringify({ email, formId: form.id, time: Date.now() }));
    } catch {}
  }, true);

  function readNewsletter() {
    try {
      const pending = JSON.parse(sessionStorage.getItem(newsletterKey) || 'null');
      if (!pending) return null;
      if (typeof pending.email !== 'string' || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(pending.email) || !pending.formId || !Number.isFinite(pending.time) || Date.now() - pending.time < 0 || Date.now() - pending.time > 1800000) {
        sessionStorage.removeItem(newsletterKey);
        return null;
      }
      return pending;
    } catch { return null; }
  }

  function syncNewsletter() {
    if (!initialized || !consentAllowed()) return;
    const pending = readNewsletter();
    if (!pending) return;
    const operation = JSON.stringify([pending.email, pending.formId, pending.time]);
    if (newsletterInFlight === operation) return;
    if (pending.confirmed !== true) {
      const form = document.getElementById(pending.formId);
      if (!form?.matches('[data-hp-personaclick-newsletter]') || !form.querySelector('[data-hp-newsletter-success]')) return;
      pending.confirmed = true;
      try { sessionStorage.setItem(newsletterKey, JSON.stringify(pending)); } catch {}
    }
    const isCurrent = () => {
      const current = readNewsletter();
      return current?.email === pending.email && current.formId === pending.formId && current.time === pending.time;
    };
    const release = () => { if (newsletterInFlight === operation) newsletterInFlight = null; };
    newsletterInFlight = operation;
    const sent = profileUpdated({ email: pending.email }, {
      newsletter: true,
      isCurrent,
      onSuccess: () => {
        if (isCurrent()) { try { sessionStorage.removeItem(newsletterKey); } catch {} }
        release();
      },
      onError: release,
    });
    if (!sent) release();
  }

  function syncCustomer() {
    if (!config.customer?.id) return;
    const id = config.customer.id;
    const createdDate = config.customerCreatedDate;
    const revision = customerRefreshRevision;
    profileUpdated(config.customer, {
      registration: newCustomerEligible(id, createdDate),
      registrationEligible: () => newCustomerEligible(id, createdDate),
      isCurrent: () => revision === customerRefreshRevision,
    });
  }

  async function refreshCustomer() {
    if (!initialized || !consentAllowed()) return;
    const revision = ++customerRefreshRevision;
    const consent = privacyRevision;
    try {
      const response = await nativeFetch(window.location.href.split('#')[0], { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const html = await response.text();
      if (revision !== customerRefreshRevision || consent !== privacyRevision || !consentAllowed()) return;
      const page = new DOMParser().parseFromString(html, 'text/html');
      const element = page.getElementById('hp-personaclick-config');
      if (!element) return;
      const fresh = JSON.parse(element.textContent);
      if (fresh.shopId !== config.shopId) return;
      config.customer = fresh.customer;
      config.customerCreatedDate = fresh.customerCreatedDate;
      config.serverTime = fresh.serverTime;
      serverTimeReceived = performance.now();
      syncCustomer();
    } catch {}
  }

  function scheduleCustomerRefresh() {
    if (document.visibilityState === 'hidden' || !initialized || !consentAllowed()) return;
    window.clearTimeout(customerRefreshTimer);
    customerRefreshTimer = window.setTimeout(() => { refreshCustomer(); syncNewsletter(); }, 100);
  }

  function isCartMutation(input) {
    try {
      const url = new URL(typeof input === 'string' ? input : input.url || String(input), window.location.href);
      return url.origin === window.location.origin && /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname);
    } catch {
      return false;
    }
  }

  window.fetch = function(input, options) {
    const consentResponse = trackingConsent?.request(input, options);
    const intent = wishlistRequest(input, options);
    const alert = alertRequest(input, options);
    const response = nativeFetch(input, options);
    if (!isCartMutation(input) && !intent && !alert && !consentResponse) return response;
    return response.then(result => {
      if (consentResponse) consentResponse(result);
      if (result.ok && isCartMutation(input)) scheduleCartSync();
      if (intent) {
        try {
          if (result.ok) result.clone().json().then(data => {
            if (data?.isSuccess === true) confirmWishlist(intent);
            else wishlistIntents.delete(intent);
          }).catch(() => wishlistIntents.delete(intent));
          else wishlistIntents.delete(intent);
        } catch { wishlistIntents.delete(intent); }
      }
      if (alert && result.ok) {
        try {
          result.clone().json().then(data => {
            if (data?.isSuccess === true && alert.revision === privacyRevision) alertChanged(alert);
          }).catch(() => {});
        } catch {}
      }
      return result;
    });
  };

  const xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url, ...args) {
    this.hpPersonaClickProductViewRequest = false;
    if (config.pageType === 'product' && config.productId && String(method).toUpperCase() === 'POST') {
      try {
        const endpoint = new URL(url, window.location.href);
        this.hpPersonaClickProductViewRequest = endpoint.origin === 'https://api.personaclick.com' && endpoint.pathname === '/push';
      } catch {}
    }
    if (this.hpPersonaClickListener) this.removeEventListener('load', this.hpPersonaClickListener);
    this.hpPersonaClickListener = null;
    if (isCartMutation(url)) {
      this.hpPersonaClickListener = () => {
        if (this.status >= 200 && this.status < 300) scheduleCartSync();
      };
      this.addEventListener('load', this.hpPersonaClickListener, { once: true });
    }
    return xhrOpen.call(this, method, url, ...args);
  };

  const xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(body) {
    if (this.hpPersonaClickProductViewRequest && typeof body === 'string') {
      try {
        const payload = JSON.parse(body);
        const fullSearchSource = payload?.recommended_by === 'full_search' || (fullSearchProductView && !payload?.recommended_by);
        if (payload?.event === 'view' && fullSearchSource && String(payload.shop_id) === String(config.shopId) && Array.isArray(payload.items) && payload.items.length === 1 && String(payload.items[0]?.id) === String(config.productId)) {
          delete payload.recommended_by;
          delete payload.recommended_code;
          body = JSON.stringify(payload);
        }
      } catch {}
    }
    return xhrSend.call(this, body);
  };

  function readSource() {
    const params = new URLSearchParams(window.location.search);
    const direct = {};
    const recommendedBy = params.get('recommended_by');
    if (['dynamic', 'instant_search', 'full_search'].includes(recommendedBy)) {
      direct.recommended_by = recommendedBy;
      if (params.get('recommended_code')) direct.recommended_code = params.get('recommended_code').slice(0,500);
      return direct;
    }
    try {
      const saved = JSON.parse(sessionStorage.getItem(sourceKey) || 'null');
      sessionStorage.removeItem(sourceKey);
      if (saved?.path === window.location.pathname && Date.now() - saved.time < 1800000) return saved.source;
    } catch {
      return direct;
    }
    return direct;
  }

  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) return;
    const recommender = link.closest('[data-recommender-code]');
    const instantSearch = link.closest('header-search, predictive-search, .personaclick-instant-search-results');
    let source = null;
    if (recommender) source = { recommended_by: 'dynamic', recommended_code: recommender.dataset.recommenderCode };
    else if (instantSearch) source = { recommended_by: 'instant_search', recommended_code: instantSearch.querySelector('[name="q"]')?.value || '' };
    else if (config.pageType === 'search') source = { recommended_by: 'full_search', recommended_code: config.searchQuery };
    if (!source) return;
    try {
      sessionStorage.setItem(sourceKey, JSON.stringify({ path: url.pathname, source, time: Date.now() }));
    } catch {
      return;
    }
  }, true);

  function initializeSdk() {
    if (initialized) return;
    if (!window.personaclick) {
      queueFunction = function() { (queueFunction.q = queueFunction.q || []).push(arguments); };
      window.personaclick = queueFunction;
    }
    try {
      window.personaclick('init', config.shopId);
    } catch {
      return;
    }
    initialized = true;
    if (!document.querySelector('script[src="https://cdn.personaclick.com/v3.js"], script[src="//cdn.personaclick.com/v3.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://cdn.personaclick.com/v3.js';
      script.async = true;
      document.head.appendChild(script);
    }
  }

  function initializeTracking() {
    initializeSdk();
    if (!initialized) return;
    if (!trackingStarted) {
      trackingStarted = true;
      if (config.pageType === 'product' && config.productId) {
        const source = { ...readSource() };
        fullSearchProductView = source.recommended_by === 'full_search';
        if (fullSearchProductView) {
          delete source.recommended_by;
          delete source.recommended_code;
        }
        send('track', 'view', { id: config.productId, ...source });
      }
      if (config.pageType === 'collection' && config.categoryId) send('track', 'category', config.categoryId);
      if (config.pageType === 'search' && config.searchQuery) send('track', 'search', config.searchQuery);
      scheduleCartSync(true);
    }
  }

  function initialize() {
    initializeTracking();
    if (!initialized) return;
    if (!consentAllowed()) {
      privacyRevision += 1;
      if (queueFunction && window.personaclick === queueFunction) {
        queueFunction.q = (queueFunction.q || []).filter(args => args[0] === 'init' || args[0] === 'track');
        profileStarted = false;
      }
      newsletterInFlight = null;
      window.clearTimeout(customerRefreshTimer);
      if (!trackingConsent || trackingConsent.resolved?.()) {
        try { sessionStorage.removeItem(newsletterKey); } catch {}
      }
      return;
    }
    if (profileStarted) {
      syncNewsletter();
      refreshCustomer();
      return;
    }
    profileStarted = true;
    syncCustomer();
    syncNewsletter();
  }

  function initializePrivacy() {
    window.clearTimeout(privacyTimer);
    const privacy = window.Shopify?.customerPrivacy;
    if (privacy && (!trackingConsent || typeof privacy.setTrackingConsent === 'function')) {
      trackingConsent?.sync();
      initialize();
      return;
    }
    if (privacyLoading || privacyAttempts >= 40) return;
    privacyAttempts += 1;
    const retry = () => {
      privacyLoading = false;
      privacyTimer = window.setTimeout(initializePrivacy, 250);
    };
    if (typeof window.Shopify?.loadFeatures !== 'function') {
      retry();
      return;
    }
    privacyLoading = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        const loadedPrivacy = window.Shopify?.customerPrivacy;
        if (error || !loadedPrivacy || (trackingConsent && typeof loadedPrivacy.setTrackingConsent !== 'function')) { retry(); return; }
        privacyLoading = false;
        initializePrivacy();
      });
    } catch { retry(); }
  }

  function observeDrawer() {
    document.querySelectorAll('cart-drawer').forEach(drawer => {
      if (drawer.dataset.hpPersonaClickObserved) return;
      drawer.dataset.hpPersonaClickObserved = 'true';
      new MutationObserver(() => {
        if (drawer.hasAttribute('open')) scheduleCartSync(true);
      }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    });
  }

  document.addEventListener('cart:change', () => scheduleCartSync());
  document.addEventListener('dialog:after-show', event => {
    if (event.target.matches?.('cart-drawer')) scheduleCartSync(true);
  }, true);
  document.addEventListener('cart:refresh', () => scheduleCartSync());
  document.addEventListener('shopify:section:load', () => { observeDrawer(); syncNewsletter(); });
  window.addEventListener('hollyWishListAppRemoveFromCart', () => scheduleCartSync(true));
  document.addEventListener('visitorConsentCollected', initialize);
  document.addEventListener('hp:tracking-consent-changed', initialize);
  window.addEventListener('pageshow', event => {
    if (event.persisted) { scheduleCartSync(true); scheduleCustomerRefresh(); }
  });
  window.addEventListener('focus', scheduleCustomerRefresh);
  document.addEventListener('visibilitychange', scheduleCustomerRefresh);
  window.HpPersonaClick = { syncCart: () => scheduleCartSync(true), profileUpdated, wishlistChanged, alertChanged };
  observeDrawer();
  initializeTracking();
  initializePrivacy();
})();
